import { ComponentType, useCallback, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { SeatPayment } from "../types/seatPayment"
import { useServer } from "./providers/server"

const TableOrderPayment: ComponentType<Props> = ({ View }) => {
    const server = useServer()
    const navigate = useNavigate()
    const { seatId } = useParams()
    const [seatPayment, setSeatPayment] = useState<SeatPayment | null>(null)
    const fetchAsync = useCallback(async () => {
        try {
            const item = await server.getSeatPayment(seatId!)
            setSeatPayment(item)
        } catch (error) {
            console.log({ error })
        }
    }, [seatId, server])
    useEffect(() => {
        fetchAsync()
    }, [fetchAsync])
    return (
        <View
            seatPayment={seatPayment}
            onClickCardPayment={() => {
                navigate(`/seat=${seatId}/table-order-payment/card`)
            }}
        />
    )
}

interface Props {
    View: TableOrderPaymentViewType
}

export default TableOrderPayment

export type TableOrderPaymentViewType = ComponentType<{
    seatPayment: SeatPayment | null
    onClickCardPayment: () => any
}>
